import { render, staticRenderFns } from "./ListItemBranch.vue?vue&type=template&id=47e30dd0&scoped=true"
import script from "./ListItemBranch.vue?vue&type=script&lang=js"
export * from "./ListItemBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e30dd0",
  null
  
)

export default component.exports